import { Component, OnInit, ViewEncapsulation} from '@angular/core';
import { HttpClient} from '@angular/common/http';

import { environment } from '.../../environments/environment';

import { Broadcaster } from '.../../environments/broadcaster';
import * as JSONEditor from 'jsoneditor';
import { AuthService } from '../../_services/index'; 
import { LoaderService } from 'app/_services/loader.service'; 
import { process, State } from '@progress/kendo-data-query';
import { GroupDescriptor, DataResult } from '@progress/kendo-data-query';
import {GridDataResult,DataStateChangeEvent} from '@progress/kendo-angular-grid';
import { Observable } from 'rxjs/Observable'; 
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import Swal from 'sweetalert2'
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { log } from 'console';

declare var $:any; 
const distinctStatus = data => data.filter((x, idx, xs) => xs.findIndex(y => y.ISACTIVE === x.ISACTIVE) === idx); 

@Component({
  selector: 'app-accessDetails',
  templateUrl: './accessDetails.component.html',
  // styleUrls: ['./users.component.css'],
  encapsulation: ViewEncapsulation.None,
  styles: ['.green .codeColumn { color: green; font-weight: bold} .red .codeColumn { color: red; font-weight: bold}'], 
})

export class AccessDetailsComponent implements OnInit 
{ 
//Variable Sections.
public showLoader:boolean;
public data: any = {}
public prjId:any;
public usersData:any;
public search:any;
public permission:any;
public editor:any
public userCd :any
public container:any
public options:any
public user:any
nameModal:any;
mobileModal:any;
EmailModal:any;
PasswordModal:any;
responceMessage:any;
public setclaimSuccess:any
success=false;
error=false;
userId:any;
newPassModal:any;
passdSuccess=false;
passdError=false;
reNewPassModal:any;
addressModal:any;
currentUsrId:any;
updtSuccess=false;
updtError=false; 
changeStatus:any;
status:any; 
titleData:any;
successMsg:any;
userCdModal:any;
confPassModal:any;
public state: State = { 
    skip: 0,
    take: 15,  
    filter: { 
      logic: 'and',
      filters: []
    }
  };
  public groups: GroupDescriptor[] = [];
  public view: Observable<GridDataResult>;
  public gridView: DataResult;
  distributionModal: any;
  checkdistributionModal: boolean;
  appUserID: any;
  errordistributionModal: boolean;
  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.loadProducts();
  }
  public distinctRole: any[]
  public distinctStatus: any[]
  private loadProducts(): void {
    this.gridDataUserList = process(this.usersData, { group: this.groups }); 
  }
  public gridDataUserList: GridDataResult  
    /*
     * Get all excel data 
    */
   public allData(): ExcelExportData {
    const result: ExcelExportData =  {
        data: this.usersData
    };
    return result;
   } 
 constructor(private http : HttpClient ,private broadcaster: Broadcaster,private auth:AuthService,private loaderService: LoaderService){
    this.setclaimSuccess = false
    this.loaderService.status.subscribe((val: boolean) =>{
        this.showLoader = val;
        this.allData = this.allData.bind(this);
        }); 

    this.checkdistributionModal = false ;
 } 



  
 
 






    


   ngOnInit()
    {
        this.prjId = this.auth.getAuthentication().projectId
        this.container = document.getElementById("jsoneditor");
        this.options = {};
        this.editor = new JSONEditor(this.container, this.options);
        $("#progress-bar").hide();
        $("#save-loader").hide()
      
    }





   




  




    // distributionModal


 







}





// WEBPACK FOOTER //
// ./src/app/superAdmin/users/accessDetails.component.ts